import { render, staticRenderFns } from "./LatestDevelopments.vue?vue&type=template&id=d13cb574&scoped=true"
import script from "./LatestDevelopments.vue?vue&type=script&lang=js"
export * from "./LatestDevelopments.vue?vue&type=script&lang=js"
import style0 from "./LatestDevelopments.vue?vue&type=style&index=0&id=d13cb574&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13cb574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d13cb574')) {
      api.createRecord('d13cb574', component.options)
    } else {
      api.reload('d13cb574', component.options)
    }
    module.hot.accept("./LatestDevelopments.vue?vue&type=template&id=d13cb574&scoped=true", function () {
      api.rerender('d13cb574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/LatestDevelopments.vue"
export default component.exports